import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconPackage } from '@redteclab/icons'

import { ContactPageCommonCtas } from './ContactPageCommonCtas'
import { ContactPageSectionFlatCta } from './ContactPageSectionFlatCta'

export const ContactPageCtaListGuest: FC<{
  handleLoginModalOpen: () => void
}> = ({ handleLoginModalOpen }) => {
  return (
    <div className="mt-6 grid grid-cols-1 gap-3 tablet:mt-0 tablet:grid-cols-2">
      <ContactPageSectionFlatCta
        data-qa-id="qa-id-help-center-login"
        onClick={handleLoginModalOpen}
        startIcon={<IconPackage className="text-dark-primary-max" />}
      >
        <FormattedMessage id="account.orders.title" />
      </ContactPageSectionFlatCta>

      <ContactPageCommonCtas isUserLoggedIn={false} />
    </div>
  )
}
